import styled from 'styled-components';
import { LINK_WATER } from 'constants/colors';

export const RequirementsList = styled.ul`
  font-size: 0.8125rem;
  list-style: inside;
  background: ${LINK_WATER};
  border-radius: 7px;
  padding: 1rem 1.5rem;
  > li {
    margin-bottom: 0.3rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;